var map = {
	"./1483527489car72.png": 63880,
	"./1485754081thumbs_dacia_duster_2014_0011.jpg": 24891,
	"./1489731109Vauxhall_Astra_COTY_2016_75x75.jpg": 36924,
	"./148973127202.jpg": 39468,
	"./148973134301.jpg": 22794,
	"./148974087602.jpg": 73265,
	"./148974185214418789671441692979safari6.png": 80928,
	"./148974186714897416301441692987car72.png": 68102,
	"./148982733902.jpg": 91924,
	"./14903316981452579453logistics3.png": 17983,
	"./14924099031441692979safari6.png": 1140,
	"./1604917175download.png": 92119,
	"./All BG Images/st-distributor-category.jpg": 64114,
	"./All BG Images/st-distributor-certificate.jpg": 16479,
	"./All BG Images/st-distributor-credits.jpg": 50296,
	"./All BG Images/st-distributor-desert.jpg": 31770,
	"./All BG Images/st-distributor-main.jpg": 24090,
	"./All BG Images/st-distributor-rentcar.jpg": 52106,
	"./All BG Images/st-distributor-schoolbus.jpg": 50285,
	"./All BG Images/st-login-bg.jpg": 71804,
	"./All BG Images/st-main-carbg.jpg": 20108,
	"./All BG Images/st-monitor-bg.jpg": 30293,
	"./BaloonIcons/Green-east.png": 28187,
	"./BaloonIcons/Green-north-east.png": 91391,
	"./BaloonIcons/Green-north-west.png": 66101,
	"./BaloonIcons/Green-north.png": 89807,
	"./BaloonIcons/Green-south-east.png": 46079,
	"./BaloonIcons/Green-south-west.png": 56586,
	"./BaloonIcons/Green-south.png": 21480,
	"./BaloonIcons/Green-west.png": 83248,
	"./BaloonIcons/Orange-east.png": 21859,
	"./BaloonIcons/Orange-north-east.png": 85119,
	"./BaloonIcons/Orange-north-west.png": 94468,
	"./BaloonIcons/Orange-north.png": 35300,
	"./BaloonIcons/Orange-south-east.png": 73566,
	"./BaloonIcons/Orange-south-west.png": 29930,
	"./BaloonIcons/Orange-south.png": 53131,
	"./BaloonIcons/Orange-west.png": 16711,
	"./BaloonIcons/Red-east.png": 60942,
	"./BaloonIcons/Red-north-east.png": 24676,
	"./BaloonIcons/Red-north-west.png": 77118,
	"./BaloonIcons/Red-north.png": 68016,
	"./BaloonIcons/Red-south-east.png": 27744,
	"./BaloonIcons/Red-south-west.png": 27320,
	"./BaloonIcons/Red-south.png": 63357,
	"./BaloonIcons/Red-west.png": 43336,
	"./BaloonIcons/Thumbs.db": 20832,
	"./BaloonIcons/Yellow-east.png": 23227,
	"./BaloonIcons/Yellow-north-east.png": 82410,
	"./BaloonIcons/Yellow-north-west.png": 35626,
	"./BaloonIcons/Yellow-north.png": 37776,
	"./BaloonIcons/Yellow-south-east.png": 18826,
	"./BaloonIcons/Yellow-south-west.png": 8384,
	"./BaloonIcons/Yellow-south.png": 20601,
	"./BaloonIcons/Yellow-west.png": 65206,
	"./BaloonIcons/gray-east.png": 82891,
	"./BaloonIcons/gray-north-east.png": 36030,
	"./BaloonIcons/gray-north-west.png": 34984,
	"./BaloonIcons/gray-north.png": 55236,
	"./BaloonIcons/gray-south-east.png": 70821,
	"./BaloonIcons/gray-south-west.png": 97318,
	"./BaloonIcons/gray-south.png": 37980,
	"./BaloonIcons/gray-west.png": 20263,
	"./Dubai-police-logo-vector.png": 52432,
	"./Kiosk/TrackeazyLogo.png": 12303,
	"./Kiosk/cab-image.png": 48722,
	"./Kiosk/cabBooking-bg.jpg": 26807,
	"./Kiosk/omanlogo.png": 6533,
	"./Power.png": 21982,
	"./RTA_Dubai_logo.png": 86,
	"./SearchIcon.svg": 42081,
	"./SecureLogin-Bg.jpg": 82239,
	"./SecurePath.png": 21776,
	"./St-Launching-dashboard.jpg": 81706,
	"./St-Launching-dashboard2.jpg": 43366,
	"./St-Launching-dashboardOld.jpg": 37976,
	"./St-Launching-dashboardold1.jpg": 92575,
	"./Starling2logo.png": 10285,
	"./TDRA-final-logo.png": 40597,
	"./ac-icon-off.png": 514,
	"./ac-icon-on.png": 2844,
	"./acceleration@2x.png": 65490,
	"./action-icon.png": 81064,
	"./adib.jpg": 20722,
	"./alert-1@2x.png": 12692,
	"./alert-icon-green.png": 73781,
	"./alert-icon-red.png": 29316,
	"./alert-temperature-dashboard.png": 94678,
	"./app-store-btn.png": 96022,
	"./appStore.png": 60992,
	"./appstoreImg.png": 87524,
	"./arrow-angle-turning-to-right@2x.png": 91921,
	"./awtl-logo-login.png": 60993,
	"./awtl-logo.png": 58436,
	"./awtl.ico": 27730,
	"./awtllogo.png": 86038,
	"./battery-green.png": 78401,
	"./battery-red.png": 22540,
	"./bg-old.png": 42244,
	"./bg.png": 74145,
	"./break@2x.png": 33906,
	"./bus-icon-blue.png": 76618,
	"./bus-icon-green.png": 94506,
	"./bus-icon-red.png": 59772,
	"./bus-icon-yellow.png": 80249,
	"./bus-icon.png": 99602,
	"./calender-1@2x.png": 3216,
	"./cancel-icon.png": 12605,
	"./cancel.png": 59685,
	"./cancelled@2x.png": 17950,
	"./car-background.jpg": 84924,
	"./car-icon-blue.png": 36798,
	"./car-icon-gray.png": 44984,
	"./car-icon-green.png": 8814,
	"./car-icon-red.png": 20545,
	"./car-icon-red1.png": 10158,
	"./car-icon-yellow.png": 90935,
	"./car-icon-yellow1.png": 85204,
	"./car-icon.jpg": 432,
	"./car-icon.png": 83176,
	"./car.png": 80941,
	"./carEvidence.png": 51933,
	"./checkRouteLogo.png": 48239,
	"./clusterMarkers/1.png": 66296,
	"./clusterMarkers/10.png": 13833,
	"./clusterMarkers/11.png": 38605,
	"./clusterMarkers/12.png": 53706,
	"./clusterMarkers/13.png": 6971,
	"./clusterMarkers/14.png": 15731,
	"./clusterMarkers/15.png": 82604,
	"./clusterMarkers/2.png": 82061,
	"./clusterMarkers/3.png": 85046,
	"./clusterMarkers/4.png": 62538,
	"./clusterMarkers/5.png": 89815,
	"./clusterMarkers/6.png": 94783,
	"./clusterMarkers/7.png": 72043,
	"./clusterMarkers/8.png": 85482,
	"./clusterMarkers/9.png": 881,
	"./clusterMarkers/Thumbs.db": 87761,
	"./clusterMarkers/yellow.png": 30750,
	"./dangerEvidence.png": 26031,
	"./data-processing.png": 85716,
	"./destination.png": 13533,
	"./detailtracking/10Ton-PickUp-black.png": 72572,
	"./detailtracking/10Ton-PickUp-gray.png": 22316,
	"./detailtracking/10Ton-PickUp-green.png": 25722,
	"./detailtracking/10Ton-PickUp-purple.png": 63989,
	"./detailtracking/10Ton-PickUp-red.png": 76651,
	"./detailtracking/10Ton-PickUp-yellow.png": 36354,
	"./detailtracking/2Ton-PickUp-black.png": 51422,
	"./detailtracking/2Ton-PickUp-gray.png": 47163,
	"./detailtracking/2Ton-PickUp-green.png": 30494,
	"./detailtracking/2Ton-PickUp-purple.png": 46041,
	"./detailtracking/2Ton-PickUp-red.png": 11948,
	"./detailtracking/2Ton-PickUp-yellow.png": 28586,
	"./detailtracking/3Ton-PickUp-gray.png": 92630,
	"./detailtracking/3Ton-PickUp-green.png": 11453,
	"./detailtracking/3Ton-PickUp-red.png": 61252,
	"./detailtracking/3Ton-PickUp-yellow.png": 82081,
	"./detailtracking/5Ton-PickUp-black.png": 5037,
	"./detailtracking/5Ton-PickUp-gray.png": 38033,
	"./detailtracking/5Ton-PickUp-green.png": 77078,
	"./detailtracking/5Ton-PickUp-purple.png": 55561,
	"./detailtracking/5Ton-PickUp-red.png": 86359,
	"./detailtracking/5Ton-PickUp-yellow.png": 62869,
	"./detailtracking/Ambulance-black.png": 996,
	"./detailtracking/Ambulance-gray.png": 40895,
	"./detailtracking/Ambulance-green.png": 66406,
	"./detailtracking/Ambulance-purple.png": 7744,
	"./detailtracking/Ambulance-red.png": 69122,
	"./detailtracking/Ambulance-yellow.png": 43245,
	"./detailtracking/Bobcat-black.png": 14882,
	"./detailtracking/Bobcat-gray.png": 90799,
	"./detailtracking/Bobcat-green.png": 56283,
	"./detailtracking/Bobcat-purple.png": 38151,
	"./detailtracking/Bobcat-red.png": 22752,
	"./detailtracking/Bobcat-yellow.png": 91306,
	"./detailtracking/Boom-Loader-black.png": 29455,
	"./detailtracking/Boom-Loader-gray.png": 31343,
	"./detailtracking/Boom-Loader-green.png": 50543,
	"./detailtracking/Boom-Loader-purple.png": 24703,
	"./detailtracking/Boom-Loader-red.png": 14101,
	"./detailtracking/Boom-Loader-yellow.png": 93871,
	"./detailtracking/Bulldozer-black.png": 83084,
	"./detailtracking/Bulldozer-gray.png": 68570,
	"./detailtracking/Bulldozer-green.png": 7235,
	"./detailtracking/Bulldozer-purple.png": 20209,
	"./detailtracking/Bulldozer-red.png": 40479,
	"./detailtracking/Bulldozer-yellow.png": 17516,
	"./detailtracking/Canter-gray.png": 99670,
	"./detailtracking/Canter-green.png": 44959,
	"./detailtracking/Canter-red.png": 45260,
	"./detailtracking/Canter-yellow.png": 77360,
	"./detailtracking/Car-black.png": 63700,
	"./detailtracking/Car-gray.png": 72113,
	"./detailtracking/Car-green.png": 55442,
	"./detailtracking/Car-purple.png": 69640,
	"./detailtracking/Car-red.png": 71330,
	"./detailtracking/Car-yellow.png": 18908,
	"./detailtracking/Coaster-Bus-black.png": 71471,
	"./detailtracking/Coaster-Bus-gray.png": 33498,
	"./detailtracking/Coaster-Bus-green.png": 81136,
	"./detailtracking/Coaster-Bus-purple.png": 20026,
	"./detailtracking/Coaster-Bus-red.png": 21698,
	"./detailtracking/Coaster-Bus-yellow.png": 77186,
	"./detailtracking/Crane-black.png": 15648,
	"./detailtracking/Crane-gray.png": 95690,
	"./detailtracking/Crane-green.png": 14117,
	"./detailtracking/Crane-purple.png": 28634,
	"./detailtracking/Crane-red.png": 30718,
	"./detailtracking/Crane-yellow.png": 17780,
	"./detailtracking/Dumper-black.png": 40731,
	"./detailtracking/Dumper-gray copy.png": 57558,
	"./detailtracking/Dumper-gray.png": 15837,
	"./detailtracking/Dumper-green.png": 95730,
	"./detailtracking/Dumper-purple.png": 86129,
	"./detailtracking/Dumper-red.png": 46150,
	"./detailtracking/Dumper-yellow.png": 71749,
	"./detailtracking/Excavator-black.png": 60235,
	"./detailtracking/Excavator-gray.png": 84038,
	"./detailtracking/Excavator-green.png": 81596,
	"./detailtracking/Excavator-purple.png": 11223,
	"./detailtracking/Excavator-red.png": 14002,
	"./detailtracking/Excavator-yellow.png": 58284,
	"./detailtracking/Forklif-black.png": 6929,
	"./detailtracking/Forklif-gray.png": 4413,
	"./detailtracking/Forklif-green.png": 48481,
	"./detailtracking/Forklif-purple.png": 57324,
	"./detailtracking/Forklif-red.png": 56190,
	"./detailtracking/Forklif-yellow.png": 18431,
	"./detailtracking/Generator-black.png": 7123,
	"./detailtracking/Generator-gray.png": 73450,
	"./detailtracking/Generator-green.png": 99304,
	"./detailtracking/Generator-purple.png": 78688,
	"./detailtracking/Generator-red.png": 93032,
	"./detailtracking/Generator-yellow.png": 43430,
	"./detailtracking/Hiace-black.png": 97354,
	"./detailtracking/Hiace-gray.png": 15175,
	"./detailtracking/Hiace-green.png": 10227,
	"./detailtracking/Hiace-purple.png": 17017,
	"./detailtracking/Hiace-red.png": 90867,
	"./detailtracking/Hiace-yellow.png": 39557,
	"./detailtracking/Hilux-black-1.png": 51053,
	"./detailtracking/Hilux-black.png": 60384,
	"./detailtracking/Hilux-gray.png": 23253,
	"./detailtracking/Hilux-green.png": 61541,
	"./detailtracking/Hilux-purple-1.png": 76515,
	"./detailtracking/Hilux-purple.png": 97824,
	"./detailtracking/Hilux-red.png": 68608,
	"./detailtracking/Hilux-yellow.png": 15880,
	"./detailtracking/JCB-black.png": 4127,
	"./detailtracking/JCB-gray.png": 33845,
	"./detailtracking/JCB-green.png": 39473,
	"./detailtracking/JCB-purple.png": 51967,
	"./detailtracking/JCB-red.png": 59947,
	"./detailtracking/JCB-yellow.png": 80852,
	"./detailtracking/Mini-Bus-black.png": 29370,
	"./detailtracking/Mini-Bus-gray.png": 75841,
	"./detailtracking/Mini-Bus-green.png": 10362,
	"./detailtracking/Mini-Bus-purple.png": 28520,
	"./detailtracking/Mini-Bus-red.png": 29657,
	"./detailtracking/Mini-Bus-yellow.png": 23802,
	"./detailtracking/Motorcycle-black.png": 94495,
	"./detailtracking/Motorcycle-gray.png": 28497,
	"./detailtracking/Motorcycle-green.png": 83532,
	"./detailtracking/Motorcycle-purple.png": 1055,
	"./detailtracking/Motorcycle-red.png": 80838,
	"./detailtracking/Motorcycle-yellow.png": 48487,
	"./detailtracking/PickUp-gray.png": 94723,
	"./detailtracking/PickUp-green.png": 80923,
	"./detailtracking/PickUp-red.png": 76026,
	"./detailtracking/PickUp-yellow.png": 15613,
	"./detailtracking/Reefer-black.png": 36077,
	"./detailtracking/Reefer-gray.png": 80963,
	"./detailtracking/Reefer-green.png": 94780,
	"./detailtracking/Reefer-purple.png": 85674,
	"./detailtracking/Reefer-red.png": 73063,
	"./detailtracking/Reefer-yellow.png": 90200,
	"./detailtracking/Roller-black.png": 91056,
	"./detailtracking/Roller-gray.png": 45959,
	"./detailtracking/Roller-green.png": 12079,
	"./detailtracking/Roller-purple.png": 18628,
	"./detailtracking/Roller-red.png": 84140,
	"./detailtracking/Roller-yellow.png": 7945,
	"./detailtracking/SUV-black.png": 53538,
	"./detailtracking/SUV-gray.png": 40185,
	"./detailtracking/SUV-green.png": 22610,
	"./detailtracking/SUV-purple.png": 1894,
	"./detailtracking/SUV-red.png": 28325,
	"./detailtracking/SUV-yellow.png": 27539,
	"./detailtracking/SchoolBus-black.png": 91602,
	"./detailtracking/SchoolBus-gray.png": 93439,
	"./detailtracking/SchoolBus-green.png": 69760,
	"./detailtracking/SchoolBus-purple.png": 24016,
	"./detailtracking/SchoolBus-red.png": 5124,
	"./detailtracking/SchoolBus-yellow.png": 20598,
	"./detailtracking/Shovel-black.png": 13563,
	"./detailtracking/Shovel-gray.png": 91585,
	"./detailtracking/Shovel-green.png": 24356,
	"./detailtracking/Shovel-purple.png": 20254,
	"./detailtracking/Shovel-red.png": 6032,
	"./detailtracking/Shovel-yellow.png": 78222,
	"./detailtracking/Smart Phone-gray.png": 89143,
	"./detailtracking/Tanker-black.png": 19858,
	"./detailtracking/Tanker-gray.png": 88928,
	"./detailtracking/Tanker-green.png": 82959,
	"./detailtracking/Tanker-purple.png": 98422,
	"./detailtracking/Tanker-red.png": 27992,
	"./detailtracking/Tanker-yellow.png": 51506,
	"./detailtracking/Tourist-Bus-black.png": 25760,
	"./detailtracking/Tourist-Bus-gray.png": 52816,
	"./detailtracking/Tourist-Bus-green.png": 30651,
	"./detailtracking/Tourist-Bus-purple.png": 40049,
	"./detailtracking/Tourist-Bus-red.png": 15963,
	"./detailtracking/Tourist-Bus-yellow.png": 56795,
	"./detailtracking/Trailer-black.png": 99333,
	"./detailtracking/Trailer-gray.png": 63897,
	"./detailtracking/Trailer-green.png": 63964,
	"./detailtracking/Trailer-purple.png": 19985,
	"./detailtracking/Trailer-red.png": 70143,
	"./detailtracking/Trailer-yellow.png": 89338,
	"./detailtracking/Truck-black.png": 81943,
	"./detailtracking/Truck-gray.png": 68865,
	"./detailtracking/Truck-green.png": 98882,
	"./detailtracking/Truck-purple.png": 20283,
	"./detailtracking/Truck-red.png": 12655,
	"./detailtracking/Truck-yellow.png": 52399,
	"./detailtracking/Urvan-black.png": 5031,
	"./detailtracking/Urvan-gray.png": 20332,
	"./detailtracking/Urvan-green.png": 66547,
	"./detailtracking/Urvan-purple.png": 10018,
	"./detailtracking/Urvan-red.png": 32034,
	"./detailtracking/Urvan-yellow.png": 92803,
	"./detailtracking/Van-black.png": 76095,
	"./detailtracking/Van-gray.png": 53827,
	"./detailtracking/Van-green.png": 81035,
	"./detailtracking/Van-purple.png": 55646,
	"./detailtracking/Van-red.png": 49809,
	"./detailtracking/Van-yellow.png": 53453,
	"./detailtracking/Yatch-black.png": 50652,
	"./detailtracking/Yatch-gray.png": 13194,
	"./detailtracking/Yatch-green.png": 12967,
	"./detailtracking/Yatch-purple.png": 2505,
	"./detailtracking/Yatch-red.png": 85609,
	"./detailtracking/Yatch-yellow.png": 65563,
	"./detailtracking/alert-icon-green.png": 47957,
	"./detailtracking/alert-icon-red.png": 50503,
	"./detailtracking/battery-green-icon.png": 61950,
	"./detailtracking/battery-red-icon.png": 18230,
	"./detailtracking/car-icon-blue.png": 22975,
	"./detailtracking/default-black.png": 96065,
	"./detailtracking/default-gray.png": 10448,
	"./detailtracking/default-green.png": 85980,
	"./detailtracking/default-purple.png": 90129,
	"./detailtracking/default-red.png": 53593,
	"./detailtracking/default-yellow.png": 60601,
	"./detailtracking/gps-icon-on-green.png": 20646,
	"./detailtracking/gps-icon-on-red.png": 94204,
	"./detailtracking/green-icon.png": 20297,
	"./detailtracking/ignition-icon-off-red.png": 11037,
	"./detailtracking/ignition-icon-off.png": 66597,
	"./detailtracking/ignition-icon-on.png": 99786,
	"./detailtracking/map-icon.png": 42121,
	"./detailtracking/red-icon.png": 30528,
	"./detailtracking/share-icon.png": 82219,
	"./detailtracking/yellow-icon.png": 82750,
	"./detailtracking_old/10Ton-gray-icon.png": 76287,
	"./detailtracking_old/10Ton-green-icon.png": 5978,
	"./detailtracking_old/10Ton-red-icon.png": 92170,
	"./detailtracking_old/10Ton-yellow-icon.png": 50242,
	"./detailtracking_old/3Ton-gray-icon.png": 77033,
	"./detailtracking_old/3Ton-green-icon.png": 10390,
	"./detailtracking_old/3Ton-red-icon.png": 87703,
	"./detailtracking_old/3Ton-yellow-icon.png": 14304,
	"./detailtracking_old/5Ton-gray-icon.png": 3521,
	"./detailtracking_old/5Ton-green-icon.png": 14608,
	"./detailtracking_old/5Ton-red-icon.png": 7603,
	"./detailtracking_old/5Ton-yellow-icon.png": 99350,
	"./detailtracking_old/Thumbs.db": 75599,
	"./detailtracking_old/Tourist-Bus-gray.png": 8805,
	"./detailtracking_old/Tourist-Bus-green.png": 84846,
	"./detailtracking_old/Tourist-Bus-red.png": 24065,
	"./detailtracking_old/Tourist-Bus-yellow.png": 9596,
	"./detailtracking_old/ac-icon-off.png": 7985,
	"./detailtracking_old/ac-icon-on.png": 28948,
	"./detailtracking_old/alert-icon-green.png": 71593,
	"./detailtracking_old/alert-icon-red.png": 12195,
	"./detailtracking_old/bobcat-roller-gray-icon.png": 38705,
	"./detailtracking_old/bobcat-roller-green-icon.png": 53426,
	"./detailtracking_old/bobcat-roller-red-icon.png": 30876,
	"./detailtracking_old/bobcat-roller-yellow-icon.png": 12517,
	"./detailtracking_old/boom-gray-icon.png": 82393,
	"./detailtracking_old/boom-green-icon.png": 91950,
	"./detailtracking_old/boom-red-icon.png": 26982,
	"./detailtracking_old/boom-yellow-icon.png": 67554,
	"./detailtracking_old/bulldozer-gray-icon.png": 51005,
	"./detailtracking_old/bulldozer-green-icon.png": 43186,
	"./detailtracking_old/bulldozer-red-icon.png": 1777,
	"./detailtracking_old/bulldozer-yellow-icon.png": 86060,
	"./detailtracking_old/bus-icon-blue.png": 98919,
	"./detailtracking_old/bus-icon-gray.png": 91239,
	"./detailtracking_old/bus-icon-green.png": 3676,
	"./detailtracking_old/bus-icon-red.png": 16174,
	"./detailtracking_old/bus-icon-yellow.png": 50071,
	"./detailtracking_old/canter-gray-icon.png": 53249,
	"./detailtracking_old/canter-green-icon.png": 64113,
	"./detailtracking_old/canter-red-icon.png": 37234,
	"./detailtracking_old/canter-yellow-icon.png": 56018,
	"./detailtracking_old/car-icon-blue.png": 64280,
	"./detailtracking_old/car-icon-gray.png": 25727,
	"./detailtracking_old/car-icon-green.png": 29057,
	"./detailtracking_old/car-icon-red.png": 85639,
	"./detailtracking_old/car-icon-yellow.png": 68318,
	"./detailtracking_old/crane-gray-icon.png": 44657,
	"./detailtracking_old/crane-green-icon.png": 2470,
	"./detailtracking_old/crane-red-icon.png": 82747,
	"./detailtracking_old/crane-yellow-icon.png": 7827,
	"./detailtracking_old/dumper-gray-icon.png": 15949,
	"./detailtracking_old/dumper-green-icon.png": 69099,
	"./detailtracking_old/dumper-red-icon.png": 92546,
	"./detailtracking_old/dumper-yellow-icon.png": 96676,
	"./detailtracking_old/excavator-gray-icon.png": 77728,
	"./detailtracking_old/excavator-green-icon.png": 74175,
	"./detailtracking_old/excavator-red-icon.png": 14329,
	"./detailtracking_old/excavator-yellow-icon.png": 9517,
	"./detailtracking_old/forklif-gray-icon.png": 98255,
	"./detailtracking_old/forklif-green-icon.png": 39213,
	"./detailtracking_old/forklif-red-icon.png": 31992,
	"./detailtracking_old/forklif-yellow-icon.png": 7277,
	"./detailtracking_old/gps-icon-off.png": 49892,
	"./detailtracking_old/gps-icon-on-green.png": 29078,
	"./detailtracking_old/gps-icon-on.png": 80967,
	"./detailtracking_old/hiace-gray-icon.png": 43165,
	"./detailtracking_old/hiace-green-icon.png": 95581,
	"./detailtracking_old/hiace-red-icon.png": 88897,
	"./detailtracking_old/hiace-yellow-icon.png": 89854,
	"./detailtracking_old/ignition-icon-off-red.png": 11690,
	"./detailtracking_old/ignition-icon-off.png": 10743,
	"./detailtracking_old/ignition-icon-on.png": 93786,
	"./detailtracking_old/jcb-gray-icon.png": 26563,
	"./detailtracking_old/jcb-green-icon.png": 25556,
	"./detailtracking_old/jcb-red-icon.png": 56799,
	"./detailtracking_old/jcb-yellow-icon.png": 71935,
	"./detailtracking_old/map-icon.png": 56192,
	"./detailtracking_old/mini-bus-gray-icon.png": 12659,
	"./detailtracking_old/mini-bus-green-icon.png": 51233,
	"./detailtracking_old/mini-bus-red-icon.png": 63863,
	"./detailtracking_old/mini-bus-yellow-icon.png": 72114,
	"./detailtracking_old/motorcycle-icon-gray.png": 21121,
	"./detailtracking_old/motorcycle-icon-green.png": 70035,
	"./detailtracking_old/motorcycle-icon-red.png": 82675,
	"./detailtracking_old/motorcycle-icon-yellow.png": 65839,
	"./detailtracking_old/pickup-icon-blue.png": 78077,
	"./detailtracking_old/pickup-icon-gray.png": 78564,
	"./detailtracking_old/pickup-icon-gray_old.png": 52605,
	"./detailtracking_old/pickup-icon-gray_old1.png": 79889,
	"./detailtracking_old/pickup-icon-green-old1.png": 73996,
	"./detailtracking_old/pickup-icon-green.png": 79824,
	"./detailtracking_old/pickup-icon-green_old.png": 59889,
	"./detailtracking_old/pickup-icon-red-old1.png": 8721,
	"./detailtracking_old/pickup-icon-red.png": 66333,
	"./detailtracking_old/pickup-icon-red_old.png": 88607,
	"./detailtracking_old/pickup-icon-yellow.png": 92791,
	"./detailtracking_old/pickup-icon-yellow_old.png": 94843,
	"./detailtracking_old/pickup-icon-yellow_old1.png": 58731,
	"./detailtracking_old/reefer-gray-icon.png": 8403,
	"./detailtracking_old/reefer-green-icon.png": 87775,
	"./detailtracking_old/reefer-red-icon.png": 5798,
	"./detailtracking_old/reefer-yellow-icon.png": 50405,
	"./detailtracking_old/roller-gray-icon.png": 82017,
	"./detailtracking_old/roller-green-icon.png": 91959,
	"./detailtracking_old/roller-red-icon.png": 85253,
	"./detailtracking_old/roller-yellow-icon.png": 75193,
	"./detailtracking_old/share-icon.png": 12928,
	"./detailtracking_old/shovel-gray-icon.png": 85402,
	"./detailtracking_old/shovel-green-icon.png": 33485,
	"./detailtracking_old/shovel-red-icon.png": 18900,
	"./detailtracking_old/shovel-yellow-icon.png": 44609,
	"./detailtracking_old/tanker-gray-icon.png": 46914,
	"./detailtracking_old/tanker-green-icon.png": 219,
	"./detailtracking_old/tanker-red-icon.png": 69561,
	"./detailtracking_old/tanker-yellow-icon.png": 70306,
	"./detailtracking_old/trailer-gray-icon.png": 32729,
	"./detailtracking_old/trailer-green-icon.png": 3112,
	"./detailtracking_old/trailer-red-icon.png": 79373,
	"./detailtracking_old/trailer-yellow-icon.png": 68355,
	"./detailtracking_old/truck-icon-blue.png": 15034,
	"./detailtracking_old/truck-icon-gray.png": 48692,
	"./detailtracking_old/truck-icon-green.png": 13810,
	"./detailtracking_old/truck-icon-red.png": 44107,
	"./detailtracking_old/truck-icon-yellow.png": 32973,
	"./detailtracking_old/urvan-gray-icon.png": 92260,
	"./detailtracking_old/urvan-green-icon.png": 83655,
	"./detailtracking_old/urvan-red-icon.png": 54285,
	"./detailtracking_old/urvan-yellow-icon.png": 22031,
	"./detailtracking_old/van-gray-icon.png": 18528,
	"./detailtracking_old/van-green-icon.png": 16164,
	"./detailtracking_old/van-red-icon.png": 49427,
	"./detailtracking_old/van-yellow-icon.png": 87490,
	"./devicePosterImage.jpg": 27552,
	"./download.png": 62177,
	"./drive7.ico": 34055,
	"./drive7/drive7-login-logo.png": 97379,
	"./drive7/drive7-login-logo_back.png": 8336,
	"./drive7/loginBg.png": 80950,
	"./drive7/video-short.mp4": 57053,
	"./drive7DashboardLogo.png": 96290,
	"./drive7LogoBig.png": 41925,
	"./drive7LogoSmall.png": 71630,
	"./driverEvidence.png": 27949,
	"./email.png": 90908,
	"./ev-front-fill.svg": 3451,
	"./flag@2x.png": 77263,
	"./fuel@2x.png": 81508,
	"./garage.png": 86548,
	"./gear-fill.png": 63525,
	"./google-play-btn.png": 96843,
	"./govdubai.png": 48758,
	"./gps-icon-off.png": 2716,
	"./gps-icon-on-green.png": 4012,
	"./gps-icon-on.png": 76534,
	"./hero-bg.webp": 15534,
	"./highspeed-1@2x.png": 25568,
	"./hospital.png": 69944,
	"./humidity-green.png": 34060,
	"./humidity.png": 85133,
	"./icon/1.png": 89150,
	"./icon/10.png": 42488,
	"./icon/11.png": 59235,
	"./icon/2.png": 51612,
	"./icon/3.png": 45201,
	"./icon/4.png": 6456,
	"./icon/5.png": 84748,
	"./icon/6.png": 35943,
	"./icon/7.png": 34862,
	"./icon/8.png": 68725,
	"./icon/9.png": 84102,
	"./ignition-icon-off-red.png": 35672,
	"./ignition-icon-off.png": 64938,
	"./ignition-icon-on.png": 3410,
	"./inner-logo-starling.png": 49729,
	"./inner-logo-swd.png": 60641,
	"./inner-logo-swd2.png": 99916,
	"./inner-logo.png": 31888,
	"./innerDashboard/circle.png": 860,
	"./innerDashboard/ellipse-455.png": 10763,
	"./innerDashboard/ellipse-455.svg": 79812,
	"./innerDashboard/ellipse-456.png": 6558,
	"./innerDashboard/ellipse-456.svg": 50905,
	"./innerDashboard/ellipse-457.png": 46138,
	"./innerDashboard/ellipse-457.svg": 14949,
	"./innerDashboard/group-362@2x.png": 79405,
	"./innerDashboard/group-363@2x.png": 63030,
	"./innerDashboard/group-364@2x.png": 74712,
	"./innerDashboard/group-365@2x.png": 84694,
	"./innerDashboard/group-366@2x.png": 16335,
	"./innerDashboard/group-367@2x.png": 82990,
	"./innerDashboard/group-368@2x.png": 52355,
	"./innerDashboard/group-369@2x.png": 3343,
	"./innerDashboard/group-370@2x.png": 62408,
	"./innerDashboard/group-371@2x.png": 64696,
	"./innerDashboard/group-372@2x.png": 55624,
	"./innerDashboard/menu-logo.png": 294,
	"./innerDashboard/menuBg.jpg": 4691,
	"./insidemap-1@2x.png": 52796,
	"./jalbootLogo.png": 30892,
	"./jalbootLogo_04.png": 16052,
	"./kebab.svg": 53479,
	"./liveTrackingMarker.png": 60581,
	"./livetracking/10Ton-PickUp-gray.png": 17778,
	"./livetracking/10Ton-PickUp-green.png": 39642,
	"./livetracking/10Ton-PickUp-red.png": 29473,
	"./livetracking/10Ton-PickUp-yellow.png": 53959,
	"./livetracking/2Ton-PickUp-black.png": 90758,
	"./livetracking/2Ton-PickUp-gray.png": 92960,
	"./livetracking/2Ton-PickUp-green.png": 86279,
	"./livetracking/2Ton-PickUp-purple.png": 5519,
	"./livetracking/2Ton-PickUp-red.png": 88213,
	"./livetracking/2Ton-PickUp-yellow.png": 49429,
	"./livetracking/3Ton-PickUp-gray.png": 73478,
	"./livetracking/3Ton-PickUp-green.png": 65570,
	"./livetracking/3Ton-PickUp-red.png": 47555,
	"./livetracking/3Ton-PickUp-yellow.png": 50201,
	"./livetracking/5Ton-PickUp-gray.png": 66496,
	"./livetracking/5Ton-PickUp-green.png": 95217,
	"./livetracking/5Ton-PickUp-red.png": 14158,
	"./livetracking/5Ton-PickUp-yellow.png": 34036,
	"./livetracking/Ambulance-black.png": 24609,
	"./livetracking/Ambulance-gray.png": 21446,
	"./livetracking/Ambulance-green.png": 57958,
	"./livetracking/Ambulance-purple.png": 64102,
	"./livetracking/Ambulance-red.png": 76730,
	"./livetracking/Ambulance-yellow.png": 38437,
	"./livetracking/Boom-Loader-black.png": 60925,
	"./livetracking/Boom-Loader-gray.png": 74150,
	"./livetracking/Boom-Loader-green.png": 58177,
	"./livetracking/Boom-Loader-purple.png": 9556,
	"./livetracking/Boom-Loader-red.png": 18743,
	"./livetracking/Boom-Loader-yellow.png": 72449,
	"./livetracking/Bulldozer-black.png": 51017,
	"./livetracking/Bulldozer-gray.png": 33771,
	"./livetracking/Bulldozer-green.png": 90813,
	"./livetracking/Bulldozer-purple.png": 27425,
	"./livetracking/Bulldozer-red.png": 72612,
	"./livetracking/Bulldozer-yellow.png": 80028,
	"./livetracking/Canter-gray.png": 81708,
	"./livetracking/Canter-green.png": 85299,
	"./livetracking/Canter-red.png": 7498,
	"./livetracking/Canter-yellow.png": 34880,
	"./livetracking/Car-black.png": 99395,
	"./livetracking/Car-gray-1.png": 52236,
	"./livetracking/Car-gray.png": 32356,
	"./livetracking/Car-green.png": 57663,
	"./livetracking/Car-purple - Copy.png": 47456,
	"./livetracking/Car-red.png": 62220,
	"./livetracking/Car-yellow.png": 16002,
	"./livetracking/Coaster-Bus-black.png": 12713,
	"./livetracking/Coaster-Bus-gray.png": 37798,
	"./livetracking/Coaster-Bus-green.png": 2847,
	"./livetracking/Coaster-Bus-purple.png": 70578,
	"./livetracking/Coaster-Bus-red.png": 18026,
	"./livetracking/Coaster-Bus-yellow.png": 7091,
	"./livetracking/Crane-black.png": 97984,
	"./livetracking/Crane-gray.png": 76966,
	"./livetracking/Crane-green.png": 13800,
	"./livetracking/Crane-purple.png": 4325,
	"./livetracking/Crane-red.png": 48612,
	"./livetracking/Crane-yellow.png": 13498,
	"./livetracking/Dumper-black.png": 16308,
	"./livetracking/Dumper-gray.png": 37026,
	"./livetracking/Dumper-green.png": 36965,
	"./livetracking/Dumper-purple.png": 57807,
	"./livetracking/Dumper-red.png": 41374,
	"./livetracking/Dumper-yellow.png": 88364,
	"./livetracking/Excavator-black.png": 26314,
	"./livetracking/Excavator-gray.png": 88972,
	"./livetracking/Excavator-green.png": 88503,
	"./livetracking/Excavator-purple.png": 88071,
	"./livetracking/Excavator-red.png": 8604,
	"./livetracking/Excavator-yellow.png": 26011,
	"./livetracking/Forklif-black.png": 66154,
	"./livetracking/Forklif-gray.png": 17806,
	"./livetracking/Forklif-green.png": 25209,
	"./livetracking/Forklif-purple.png": 23890,
	"./livetracking/Forklif-red.png": 50047,
	"./livetracking/Forklif-yellow.png": 39913,
	"./livetracking/Generator-black.png": 94452,
	"./livetracking/Generator-gray.png": 44862,
	"./livetracking/Generator-green.png": 10408,
	"./livetracking/Generator-purple.png": 61509,
	"./livetracking/Generator-red.png": 58327,
	"./livetracking/Generator-yellow.png": 38205,
	"./livetracking/Hiace-black.png": 68015,
	"./livetracking/Hiace-gray.png": 2621,
	"./livetracking/Hiace-green.png": 8273,
	"./livetracking/Hiace-red.png": 58411,
	"./livetracking/Hiace-yellow.png": 59010,
	"./livetracking/Hilux-gray.png": 15849,
	"./livetracking/Hilux-green.png": 90508,
	"./livetracking/Hilux-red.png": 82723,
	"./livetracking/Hilux-yellow.png": 21106,
	"./livetracking/JCB-black.png": 59207,
	"./livetracking/JCB-gray.png": 85340,
	"./livetracking/JCB-green.png": 17908,
	"./livetracking/JCB-red.png": 52299,
	"./livetracking/JCB-yellow.png": 45851,
	"./livetracking/Mini-Bus-gray.png": 83822,
	"./livetracking/Mini-Bus-green.png": 62325,
	"./livetracking/Mini-Bus-red.png": 26569,
	"./livetracking/Mini-Bus-yellow.png": 54385,
	"./livetracking/Motorcycle-black.png": 80455,
	"./livetracking/Motorcycle-gray.png": 72418,
	"./livetracking/Motorcycle-green.png": 88307,
	"./livetracking/Motorcycle-purple.png": 98242,
	"./livetracking/Motorcycle-red.png": 98272,
	"./livetracking/Motorcycle-yellow.png": 15337,
	"./livetracking/PickUp-gray.png": 5184,
	"./livetracking/PickUp-green.png": 81352,
	"./livetracking/PickUp-red.png": 46022,
	"./livetracking/PickUp-yellow.png": 16343,
	"./livetracking/Roller-black.png": 43504,
	"./livetracking/Roller-gray.png": 3300,
	"./livetracking/Roller-green.png": 64103,
	"./livetracking/Roller-purple.png": 32075,
	"./livetracking/Roller-red.png": 32029,
	"./livetracking/Roller-yellow.png": 75696,
	"./livetracking/SUV-black.png": 96171,
	"./livetracking/SUV-gray.png": 88530,
	"./livetracking/SUV-green.png": 45484,
	"./livetracking/SUV-purple.png": 6463,
	"./livetracking/SUV-red.png": 4692,
	"./livetracking/SUV-yellow.png": 22719,
	"./livetracking/SchoolBus-black.png": 61891,
	"./livetracking/SchoolBus-gray.png": 61488,
	"./livetracking/SchoolBus-green.png": 34487,
	"./livetracking/SchoolBus-red.png": 90679,
	"./livetracking/SchoolBus-yellow.png": 14138,
	"./livetracking/Tanker-black.png": 43898,
	"./livetracking/Tanker-gray.png": 47445,
	"./livetracking/Tanker-green.png": 94121,
	"./livetracking/Tanker-purple.png": 82178,
	"./livetracking/Tanker-red.png": 48442,
	"./livetracking/Tanker-yellow.png": 4218,
	"./livetracking/Tourist-Bus-black.png": 15913,
	"./livetracking/Tourist-Bus-gray.png": 84950,
	"./livetracking/Tourist-Bus-green.png": 92898,
	"./livetracking/Tourist-Bus-purple.png": 17994,
	"./livetracking/Tourist-Bus-red.png": 24902,
	"./livetracking/Tourist-Bus-yellow.png": 3368,
	"./livetracking/Truck-black.png": 24910,
	"./livetracking/Truck-gray.png": 58186,
	"./livetracking/Truck-green.png": 51762,
	"./livetracking/Truck-purple.png": 45354,
	"./livetracking/Truck-red.png": 42099,
	"./livetracking/Truck-yellow.png": 44651,
	"./livetracking/Urvan-black.png": 79533,
	"./livetracking/Urvan-gray.png": 62522,
	"./livetracking/Urvan-green.png": 34285,
	"./livetracking/Urvan-purple.png": 11145,
	"./livetracking/Urvan-red.png": 30283,
	"./livetracking/Urvan-yellow.png": 26986,
	"./livetracking/Van-gray.png": 80898,
	"./livetracking/Van-green.png": 28987,
	"./livetracking/Van-red.png": 53507,
	"./livetracking/Van-yellow.png": 39461,
	"./livetracking/Yatch-black.png": 23123,
	"./livetracking/Yatch-gray.png": 40048,
	"./livetracking/Yatch-green.png": 69004,
	"./livetracking/Yatch-purple.png": 14433,
	"./livetracking/Yatch-red.png": 77319,
	"./livetracking/Yatch-yellow.png": 7960,
	"./livetracking/car-icon-blue.png": 41982,
	"./livetracking/default-black.png": 54024,
	"./livetracking/default-gray.png": 46298,
	"./livetracking/default-green.png": 78090,
	"./livetracking/default-purple.png": 79735,
	"./livetracking/default-red.png": 25600,
	"./livetracking/default-yellow.png": 85781,
	"./location-pin.png": 94646,
	"./locationLogo.jpg": 53313,
	"./locationLogo1.png": 76241,
	"./location_show.png": 5380,
	"./lock-icon.png": 12039,
	"./login-logo-W.png": 83554,
	"./login-logo-starling.png": 74597,
	"./login-logo.png": 14236,
	"./loginBg.png": 95322,
	"./logo-white.png": 36286,
	"./logoNew.jpg": 5105,
	"./logo_icon.png": 52969,
	"./map-car-icon-green.png": 68885,
	"./map-icon.png": 24626,
	"./map-image.png": 13052,
	"./map-lock-icon.png": 96855,
	"./mapBg.jpg": 69562,
	"./mapIcon/gps_icon.png": 43250,
	"./mapImage.png": 71004,
	"./marker.png": 99997,
	"./masreq.jpg": 37996,
	"./menuBg.jpg": 87929,
	"./meter.png": 64031,
	"./new_login_bg.png": 47383,
	"./no-data.png": 76977,
	"./opt10.png": 41762,
	"./opt9.png": 14396,
	"./opt9.svg": 2802,
	"./origin.png": 12822,
	"./outsidemap-1@2x.png": 29869,
	"./overdue-2@2x.png": 41810,
	"./parking@2x.png": 71828,
	"./petrol.png": 56940,
	"./pickup-icon-blue.png": 86576,
	"./pickup-icon-gray.png": 23235,
	"./pickup-icon-green.png": 77977,
	"./pickup-icon-red.png": 27606,
	"./pickup-icon-yellow.png": 34184,
	"./pickup-icon.png": 36648,
	"./pin.png": 81441,
	"./play-icon.png": 80531,
	"./playStore.png": 45229,
	"./playstoreImg.jpg": 69991,
	"./police.png": 64262,
	"./power-1@2x.png": 19592,
	"./power.svg": 91694,
	"./processing-time.png": 55656,
	"./secure.ico": 99929,
	"./securetrack.png": 74784,
	"./sendCmd/Thumbs.db": 96902,
	"./sendCmd/engine-off-icon.png": 46762,
	"./sendCmd/engine-on-icon.png": 94571,
	"./sendCmd/get-position-icon.png": 73877,
	"./sendCmd/lock-icon.png": 35418,
	"./sendCmd/unlock-icon.png": 56421,
	"./sensor_temp_dashboard.png": 51311,
	"./share-icon.png": 43105,
	"./siradubai.png": 23871,
	"./sml-logo.png": 80433,
	"./st-car.png": 75575,
	"./st-credit-arrow.png": 87650,
	"./st-distributor-category.jpg": 6671,
	"./st-distributor-certificate.jpg": 20647,
	"./st-distributor-credits.jpg": 62626,
	"./st-distributor-desert.jpg": 44005,
	"./st-distributor-main.jpg": 68626,
	"./st-distributor-rentcar.jpg": 44310,
	"./st-distributor-schoolbus.jpg": 58090,
	"./st-login-bg.jpg": 21526,
	"./st-main-carbg.jpg": 39229,
	"./st-monitor-bg.jpg": 68840,
	"./st-monitor-new.png": 19228,
	"./st-monitor-renew.png": 83428,
	"./starling-eye-small.png": 39809,
	"./starling.ico": 60410,
	"./starlingLogo1.png": 93512,
	"./starlinglogo.png": 9791,
	"./success.png": 83513,
	"./sw-dashboard-ring.png": 46610,
	"./sw-dashboard-ringblack.png": 73516,
	"./swd-dashboard-st.png": 83643,
	"./swd-dashboard.png": 94684,
	"./swd-login.png": 995,
	"./technauto-logo.png": 50605,
	"./technauto-sml.png": 78966,
	"./technauto.ico": 83268,
	"./temprature_icon_temp_dashboard.png": 80903,
	"./test.png": 79543,
	"./thermometer-half-black.png": 53853,
	"./thermometer-half-green.png": 28670,
	"./thermometer-half.png": 56604,
	"./time-left@2x.png": 77447,
	"./trackeazy-logo.png": 89451,
	"./trackeazy-sml.png": 46046,
	"./trackeazyLogo.png": 65704,
	"./tracksmartbg.png": 55307,
	"./trip-copy.png": 67709,
	"./truck-icon-blue.png": 3458,
	"./truck-icon-gray.png": 46418,
	"./truck-icon-green.png": 89157,
	"./truck-icon-red.png": 27801,
	"./truck-icon-yellow.png": 16155,
	"./user-icon.png": 2026,
	"./userPhoto.jpg": 81920,
	"./van-icon.png": 24718,
	"./van.png": 71276,
	"./vehicle-details1.png": 2265,
	"./vehicle-details2.png": 88044,
	"./vehicle-details3.png": 64650,
	"./vehicle-details4.png": 40384,
	"./vehicle-details5.png": 6316,
	"./vehicle-details6.png": 91487,
	"./vehicle-details7.png": 47188,
	"./vehicle-type-car.png": 84833,
	"./vehicleLoc.jpg": 16150,
	"./vehicle_temp_dashboard.png": 68909,
	"./video/video-short.mp4": 62743,
	"./waypoints.png": 98306,
	"./white-logo.png": 88990,
	"./yatch-white.png": 54977,
	"./yatch-white.svg": 83730,
	"./yatch.png": 27400,
	"./yatch.svg": 13032,
	"./yatch01.svg": 8142,
	"./yatch1.png": 92143,
	"./yatch2.png": 10012,
	"./yatch3.png": 69145,
	"./yatch4.png": 60487,
	"./zoom-icon copy.png": 31296,
	"./zoom-icon.png": 36260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;